import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Card, Table, Select, Input, Button, message } from 'antd'
import { req_list_ccw_choiceCourse, req_add_ccw_courseOutline } from '../../api'

import { getNowAcademicYear, getNowAcademicSemester } from '../../utils/dateUtil'
import { usrRole } from '../../utils/dataUtil'


class ObjectCourseAddModal extends Component {

    state = {
        loading: false,
        deviceWidth: 0,
        userLevel: 'NORMAL',
        item: {},
        // 分頁參數
        items: [],
        searchField: 'CourseTeacherId',
        searchValue: this.props.user.userCode,

        nowAcademicYear: getNowAcademicYear(new Date()),
        nowAcademicSemester: getNowAcademicSemester(new Date()),
    }


    UNSAFE_componentWillMount() {
        this.api_list_items()
    }

    componentDidMount() {
        this.init()
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_list_items = async () => {
        const { nowAcademicYear, nowAcademicSemester, searchField, searchValue } = this.state
        const { token } = this.props.user

        const result = await req_list_ccw_choiceCourse(nowAcademicYear, nowAcademicSemester, searchField, searchValue, token)
        if (result.total > 0) {
            const { data } = result
            const items = data
            this.setState({ items })
            console.log(data)
        } else {
            const items = []
            this.setState({ items })
        }
    }

    api_add_item = async (item) => {
        const { token } = this.props.user
        this.setState({ loading: true })
        const result = await req_add_ccw_courseOutline(item, token)
        this.setState({ loading: false })
        if (result.status === "success") {
            // console.log(result)
            this.api_list_items()
            message.success(result.message)
        } else {
            message.error(result.message)
        }
    }


    // 數據配置設定 ////////////////////////////////////////////// 

    init = () => {
        const { role } = this.props.user
        var userLevel = usrRole(role)
        this.setState({ userLevel: userLevel })
    }


    handle_add_event = (item) => {
        this.api_add_item(item)
    }

    /////////////////////////////////////////////////////////////    

    render() {
        const { loading, userLevel, items, searchField, searchValue } = this.state
        const columns = [
            {
                title: '學年/期',
                width: 20,
                responsive: ['md'],
                render: (item) => {
                    const { AcademicYear, AcademicSemester } = item
                    return (
                        <>{AcademicYear}/{AcademicSemester}</>
                    )
                },
            },
            {
                title: '開課流水號',
                responsive: ['md'],
                dataIndex: 'OpenCourseIdKey',
                width: 20,
            },
            {
                title: '課程名稱',
                dataIndex: 'OpenCourseTwName',
                width: 80,
            },
            {
                title: '老師姓名',
                responsive: ['md'],
                dataIndex: 'CourseTeacherName',
                width: 30,
            },
            {
                title: '',
                dataIndex: '',
                width: 50,
                render: (item) => {
                    return (
                        <>
                            <button type="button" className="btn btn-outline-dark btn-sm" onClick={() => this.handle_add_event(item)}><i className="fas fa-plus-circle"></i><span style={{ marginLeft: '2px' }}>  加入</span></button>
                        </>
                    )
                },
            },
        ]
        const title = userLevel === 'MANAGER' ? (
            <>
                <Select value={searchField} style={{ width: 120, backgroundColor: 'LightCyan' }} onChange={value => this.setState({ searchField: value })}>
                    <Select.Option value='CourseTeacherId'>老師職號</Select.Option>
                    <Select.Option value='CourseTeacherName'>老師名稱</Select.Option>
                    <Select.Option value='OpenCourseTwName'>課程名稱</Select.Option>
                </Select>
                <Input placeholder="關鍵字" style={{ width: 80, margin: '0 5px', backgroundColor: 'LightYellow' }} value={searchValue} onChange={event => this.setState({ searchValue: event.target.value })} />
                <Button type='primary' onClick={() => this.api_list_items()}><i className="fas fa-search element-hidden"></i><span style={{ marginLeft: '4px' }}>查詢</span></Button>
            </>
        ) : ''

        return (
            <Card title={title} >
                <Table loading={loading} dataSource={items} columns={columns} pagination={false} />
            </Card>
        )
    }

}

export default connect(
    state => ({ user: state.user }),
    {}
)(ObjectCourseAddModal)